module.exports = __webpack_public_path__ + "static/media/req-binding.c2c1708a.svg";